import React from 'react';
import EntityManagementRouter from './EntityManagementRouter';

export default function EntityManagementPage() {
  return <EntityManagementRouter />;
}